import ContractDetails from "./ContractDetails";
import Confirm from "./Confirm";

import SignStatus from "./SignStatus";
import Parties from "./Parties";
import Attachments from "./Attachments";
import ExistingDocument from "./ExistingDocument";

// Map of chapterdef KEY: Component
export default {
  PARTIES: Parties,
  EXISTINGDOC: ExistingDocument,
  ATTACHMENTS: Attachments,
  CONTRACT: ContractDetails,

  SIGN_STATUS: SignStatus,
  CONFIRM: Confirm,
};
